<template>
  <div class="px-4">
    <guide-title-bar :title="guide ? guide.title : ''" @back="$emit('back')"></guide-title-bar>
    <!-- <v-layout v-if="start == true" class="d-flex align-center wrap py-12" column>
      <h2 class="display-1 pb-4 my-12 cols-12">Great, let's set it all up!</h2>
      <v-btn color="primary" @click="start = false" class="px-4">
        Continue
      </v-btn>
    </v-layout> -->
    <v-stepper v-model="e1" class="elevation-0" non-linear>
      <v-stepper-header
        v-if="guide.steps.length > 1"
        class="elevation-0"
        style="max-width: 500px;margin-left: auto; margin-right: auto;"
      >
        <v-stepper-step
          :complete="context.title.length > 0"
          :step="1"
          editable
          edit-icon="check"
          complete-icon="check"
        >
          Set Topic
        </v-stepper-step>
        <v-stepper-step
          v-if="guide.steps[1]"
          :complete="context.concerns.length > 0"
          :step="2"
          editable
          edit-icon="check"
          complete-icon="check"
        >
          Add Pages
        </v-stepper-step>
        <v-stepper-step
          v-if="guide.steps[2]"
          :complete="e1 > 3"
          :step="3"
          editable
          edit-icon="check"
          complete-icon="check"
        >
          Add Research Cards
        </v-stepper-step>
      </v-stepper-header>
      <v-stepper-items>
        <v-stepper-content :step="1">
          <guide-step-1
            v-model="context.title"
            :step1="guide.steps[0]"
            @next="e1++"
            :focus="e1 == 1"
          ></guide-step-1>
        </v-stepper-content>
        <v-stepper-content :step="2">
          <guide-step-2
            v-if="guide.steps[1]"
            v-model="context.concerns"
            :step="guide.steps[1]"
          ></guide-step-2>
          <v-spacer></v-spacer>
        </v-stepper-content>
        <v-stepper-content :step="3">
          <guide-step-3 v-if="guide.steps[2]" v-model="context.concerns" :step="guide.steps[2]">
          </guide-step-3>
          <v-spacer></v-spacer>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
    <v-row v-if="!start">
      <v-spacer class="grow"></v-spacer>
      <v-btn v-if="e1 < guide.steps.length" color="primary" @click="e1++">
        Continue
      </v-btn>
      <v-btn v-else :disabled="context.title.length <= 0" color="primary" @click="completeContext">
        Create Context
      </v-btn>
    </v-row>
  </div>
</template>

<script>
import GuideTitleBar from './GuideTitleBar';
import GuideStep1 from './GuideStep1';
import GuideStep2 from './GuideStep2';
import GuideStep3 from './GuideStep3';

import { mapActions, mapState } from 'vuex';

export default {
  components: { GuideTitleBar, GuideStep1, GuideStep2, GuideStep3 },
  props: ['guide'],
  data() {
    return {
      start: false,
      e1: 1,
      context: {
        title: '',
        concerns: []
      }
    };
  },
  computed: {
    ...mapState('views/newContext', ['setup', 'newContextId'])
  },
  methods: {
    ...mapActions('context', ['addSection', 'updateContextText']),
    ...mapActions('pages', ['addPage']),
    async completeContext() {
      this.updateContextText({ text: this.context.title, contextId: this.newContextId });
      // const section = await this.addSection({
      //   contextId: this.newContextId,
      //   text: 'Concerns & Considerations',
      //   order: 1
      // });
      this.context.concerns.forEach((c, n) => {
        const template = [];
        c.questions.forEach(q => {
          template.push({ title: q.text, summary: '' });
        });
        this.addPage({
          title: c.text,
          order: n,
          contextId: this.newContextId,
          template,
          batchSync: false,
          trackEvent: false
        });
      });

      this.$router
        .push({ name: 'context', params: { contextId: this.newContextId } })
        .catch(e => {});
    }
  }
};
</script>

<style></style>
